export const REGISTER_PASSWORD_MIN_LENGTH = 8

export const REGISTER_PASSWORD_MEDIUM_REGEX =
  '^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[^a-zA-Z0-9]).{6,}$'

export const REGISTER_PASSWORD_STRONG_REGEX =
  '^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[^a-zA-Z0-9]).{8,}$'

export function getRegisterPasswordValidationErrorI18nKey(password) {
  if (!password) {
    return 'validation.required'
  }

  if (password.length < REGISTER_PASSWORD_MIN_LENGTH) {
    return 'register.passwordTooShort'
  }

  if (!/[a-z]/.test(password)) {
    return 'register.passwordMissingLowercase'
  }

  if (!/[A-Z]/.test(password)) {
    return 'register.passwordMissingUppercase'
  }

  if (!/\d/.test(password)) {
    return 'register.passwordMissingNumber'
  }

  if (!/[^a-zA-Z0-9]/.test(password)) {
    return 'register.passwordMissingSpecialCharacter'
  }

  return null
}

export function isRegisterPasswordValid(password) {
  return getRegisterPasswordValidationErrorI18nKey(password) === null
}

export function getRegisterPasswordStrengthLevel(password) {
  if (!password) {
    return 0
  }

  if (new RegExp(REGISTER_PASSWORD_STRONG_REGEX).test(password)) {
    return 3
  }

  if (new RegExp(REGISTER_PASSWORD_MEDIUM_REGEX).test(password)) {
    return 2
  }

  return 1
}
